export class SiteSwitcher extends HTMLElement {
	static {
		if (window.customElements.get("site-switcher") === undefined) {
			window.customElements.define("site-switcher", SiteSwitcher);
		}
	}

	get [Symbol.toStringTag]() {
		return this.tagName;
	}

	connectedCallback() {
		if (!this.isConnected) {
			return;
		}

		// Don't show the dialog again when the user has previously chosen to stay on the site.
		if (this.#hasPreviouslyStayedOnSite()) {
			this.remove();
			return;
		}

		const dialog = /** @type {HTMLDialogElement} */ (
			this.querySelector(".js-SiteSwitcher-dialog")
		);

		// Light-dismiss/Escape means the user wants to stay on the page and so the storage flag needs to be set here, too.
		dialog.addEventListener("cancel", this.#storeHasPreviouslyStayedOnSite);

		// Remember if the user chooses to stay on the site so we can avoid showing the dialog on revisits.
		for (const element of dialog.querySelectorAll(".SiteSwitcher-button")) {
			if (element instanceof HTMLButtonElement) {
				element.addEventListener("click", () => {
					dialog.requestClose();
					this.#storeHasPreviouslyStayedOnSite();
				});
			}
		}

		dialog.showModal();
	}

	#hasPreviouslyStayedOnSite() {
		try {
			return (
				window.sessionStorage.getItem("hasPreviouslyStayedOnSite") === "true"
			);
		} catch {
			// Ignore any storage exception.
			return false;
		}
	}

	#storeHasPreviouslyStayedOnSite() {
		try {
			window.sessionStorage.setItem("hasPreviouslyStayedOnSite", "true");
		} catch {
			// Ignore any storage exception.
		}
	}
}
